import { useCommonReducer } from '@components/Shared/State/hooks';
import { GetCustomer } from '@themes/common/data';
const useCustomerReducer = () => useCommonReducer('CUSTOMER', {
    customer: null,
    shopifyCustomer: GetCustomer(),
});
export default useCustomerReducer;
